module.exports = __webpack_public_path__ + "static/media/bavugamenshi_kinyinya1.e676f812.jpg";